function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__a",
  x1: 1167.38,
  y1: -778.31,
  x2: 1997.12,
  y2: -778.31,
  gradientTransform: "rotate(95.08 1512.25 -454.69)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b72357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#ed1962"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f68943"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__c",
  x1: 1168.36,
  y1: -774.24,
  x2: 2004,
  y2: -774.24,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__d",
  x1: 1169.33,
  y1: -770.34,
  x2: 2011.25,
  y2: -770.34,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__e",
  x1: 1170.21,
  y1: -766.47,
  x2: 2017.99,
  y2: -766.47,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__f",
  x1: 1171.19,
  y1: -762.61,
  x2: 2025.13,
  y2: -762.61,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__g",
  x1: 1172.17,
  y1: -758.68,
  x2: 2031.77,
  y2: -758.68,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__h",
  x1: 1173.04,
  y1: -754.71,
  x2: 2038.63,
  y2: -754.71,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__i",
  x1: 1174.01,
  y1: -750.95,
  x2: 2045.76,
  y2: -750.95,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__j",
  x1: 1174.99,
  y1: -747.09,
  x2: 2052.6,
  y2: -747.09,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__k",
  x1: 1175.87,
  y1: -742.91,
  x2: 2059.49,
  y2: -742.91,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__l",
  x1: 1176.85,
  y1: -739,
  x2: 2066.33,
  y2: -739,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__m",
  x1: 1177.83,
  y1: -735.14,
  x2: 2073.57,
  y2: -735.14,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__n",
  x1: 1178.7,
  y1: -731.37,
  x2: 2080.3,
  y2: -731.37,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__o",
  x1: 1179.68,
  y1: -727.36,
  x2: 2087.36,
  y2: -727.36,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__p",
  x1: 1180.65,
  y1: -723.48,
  x2: 2094.1,
  y2: -723.48,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__q",
  x1: 1181.53,
  y1: -719.62,
  x2: 2101.24,
  y2: -719.62,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__r",
  x1: 1182.51,
  y1: -715.66,
  x2: 2108.09,
  y2: -715.66,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__s",
  x1: 1183.49,
  y1: -711.75,
  x2: 2115.34,
  y2: -711.75,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__t",
  x1: 1184.36,
  y1: -707.76,
  x2: 2121.8,
  y2: -707.76,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__u",
  x1: 1185.34,
  y1: -703.9,
  x2: 2128.84,
  y2: -703.9,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__v",
  x1: 1186.32,
  y1: -699.9,
  x2: 2135.9,
  y2: -699.9,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__w",
  x1: 1187.2,
  y1: -696.02,
  x2: 2142.74,
  y2: -696.02,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__x",
  x1: 1188.17,
  y1: -692.15,
  x2: 2149.58,
  y2: -692.15,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__y",
  x1: 1189.14,
  y1: -688.38,
  x2: 2156.41,
  y2: -688.38,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__z",
  x1: 1190.12,
  y1: -684.38,
  x2: 2163.67,
  y2: -684.38,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__A",
  x1: 1191,
  y1: -680.51,
  x2: 2170.41,
  y2: -680.51,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__B",
  x1: 1191.98,
  y1: -676.65,
  x2: 2177.55,
  y2: -676.65,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__C",
  x1: 1198.93,
  y1: -672.68,
  x2: 2178.33,
  y2: -672.68,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__D",
  x1: 1205.87,
  y1: -668.72,
  x2: 2179.42,
  y2: -668.72,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__E",
  x1: 1212.72,
  y1: -664.88,
  x2: 2179.98,
  y2: -664.88,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__F",
  x1: 1219.66,
  y1: -660.92,
  x2: 2181.07,
  y2: -660.92,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__G",
  x1: 1226.61,
  y1: -656.96,
  x2: 2182.16,
  y2: -656.96,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__H",
  x1: 1233.56,
  y1: -653,
  x2: 2183.14,
  y2: -653,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__I",
  x1: 1240.51,
  y1: -649.08,
  x2: 2184.01,
  y2: -649.08,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__J",
  x1: 1247.46,
  y1: -645.11,
  x2: 2184.9,
  y2: -645.11,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__K",
  x1: 1254.4,
  y1: -641.36,
  x2: 2186.25,
  y2: -641.36,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__L",
  x1: 1261.35,
  y1: -637.44,
  x2: 2186.93,
  y2: -637.44,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__M",
  x1: 1268.2,
  y1: -633.57,
  x2: 2187.9,
  y2: -633.57,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__N",
  x1: 1275.14,
  y1: -629.59,
  x2: 2188.59,
  y2: -629.59,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__O",
  x1: 1282.09,
  y1: -625.64,
  x2: 2189.78,
  y2: -625.64,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__P",
  x1: 1289.04,
  y1: -621.82,
  x2: 2190.64,
  y2: -621.82,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__Q",
  x1: 1295.98,
  y1: -617.86,
  x2: 2191.72,
  y2: -617.86,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__R",
  x1: 1302.93,
  y1: -613.88,
  x2: 2192.41,
  y2: -613.88,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__S",
  x1: 1309.88,
  y1: -610.02,
  x2: 2193.47,
  y2: -610.02,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__T",
  x1: 1316.73,
  y1: -606.2,
  x2: 2194.33,
  y2: -606.2,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__U",
  x1: 1323.68,
  y1: -602.24,
  x2: 2195.42,
  y2: -602.24,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__V",
  x1: 1330.62,
  y1: -598.27,
  x2: 2196.21,
  y2: -598.27,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__W",
  x1: 1337.57,
  y1: -594.4,
  x2: 2197.18,
  y2: -594.4,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__X",
  x1: 1344.52,
  y1: -590.5,
  x2: 2198.46,
  y2: -590.5,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__Y",
  x1: 1351.46,
  y1: -586.53,
  x2: 2199.24,
  y2: -586.53,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__Z",
  x1: 1358.41,
  y1: -582.57,
  x2: 2200.33,
  y2: -582.57,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aa",
  x1: 1365.26,
  y1: -578.73,
  x2: 2200.89,
  y2: -578.73,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ab",
  x1: 1372.2,
  y1: -574.97,
  x2: 2201.94,
  y2: -574.97,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ac",
  x1: 1379.23,
  y1: -570.66,
  x2: 2203.01,
  y2: -570.66,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ad",
  x1: 1386.25,
  y1: -566.67,
  x2: 2204.33,
  y2: -566.67,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ae",
  x1: 1393.27,
  y1: -562.67,
  x2: 2205.55,
  y2: -562.67,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__af",
  x1: 1400.3,
  y1: -558.57,
  x2: 2206.78,
  y2: -558.57,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ag",
  x1: 1407.32,
  y1: -554.35,
  x2: 2207.74,
  y2: -554.35,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ah",
  x1: 1414.35,
  y1: -550.3,
  x2: 2208.86,
  y2: -550.3,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ai",
  x1: 1421.37,
  y1: -546.4,
  x2: 2210.07,
  y2: -546.4,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aj",
  x1: 1428.39,
  y1: -542.4,
  x2: 2211.29,
  y2: -542.4,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ak",
  x1: 1435.41,
  y1: -538.3,
  x2: 2212.52,
  y2: -538.3,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__al",
  x1: 1442.43,
  y1: -534.09,
  x2: 2213.68,
  y2: -534.09,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__am",
  x1: 1449.45,
  y1: -530.09,
  x2: 2214.9,
  y2: -530.09,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__an",
  x1: 1456.48,
  y1: -525.99,
  x2: 2216.13,
  y2: -525.99,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ao",
  x1: 1463.5,
  y1: -521.99,
  x2: 2217.35,
  y2: -521.99,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ap",
  x1: 1470.53,
  y1: -517.73,
  x2: 2218.21,
  y2: -517.73,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aq",
  x1: 1477.55,
  y1: -513.68,
  x2: 2219.44,
  y2: -513.68,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ar",
  x1: 1484.57,
  y1: -509.72,
  x2: 2220.65,
  y2: -509.72,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__as",
  x1: 1491.6,
  y1: -505.72,
  x2: 2221.86,
  y2: -505.72,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__at",
  x1: 1498.62,
  y1: -501.71,
  x2: 2222.78,
  y2: -501.71,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__au",
  x1: 1505.64,
  y1: -497.52,
  x2: 2224.24,
  y2: -497.52,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__av",
  x1: 1512.67,
  y1: -493.42,
  x2: 2225.47,
  y2: -493.42,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aw",
  x1: 1519.69,
  y1: -489.42,
  x2: 2226.69,
  y2: -489.42,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ax",
  x1: 1526.71,
  y1: -485.42,
  x2: 2227.91,
  y2: -485.42,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ay",
  x1: 1533.74,
  y1: -481.3,
  x2: 2228.75,
  y2: -481.3,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__az",
  x1: 1540.76,
  y1: -477.1,
  x2: 2230,
  y2: -477.1,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aA",
  x1: 1547.79,
  y1: -473,
  x2: 2231.23,
  y2: -473,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aB",
  x1: 1549.02,
  y1: -468.9,
  x2: 2238.26,
  y2: -468.9,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aC",
  x1: 1550.14,
  y1: -465.09,
  x2: 2245.15,
  y2: -465.09,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aD",
  x1: 1551.27,
  y1: -461,
  x2: 2252.47,
  y2: -461,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aE",
  x1: 1552.5,
  y1: -456.9,
  x2: 2259.5,
  y2: -456.9,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aF",
  x1: 1553.63,
  y1: -452.79,
  x2: 2266.43,
  y2: -452.79,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aG",
  x1: 1554.86,
  y1: -448.69,
  x2: 2273.46,
  y2: -448.69,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aH",
  x1: 1555.99,
  y1: -444.77,
  x2: 2280.15,
  y2: -444.77,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aI",
  x1: 1557.22,
  y1: -440.69,
  x2: 2287.48,
  y2: -440.69,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aJ",
  x1: 1558.35,
  y1: -436.48,
  x2: 2294.43,
  y2: -436.48,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aK",
  x1: 1559.48,
  y1: -432.32,
  x2: 2301.37,
  y2: -432.32,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aL",
  x1: 1560.71,
  y1: -428.27,
  x2: 2308.39,
  y2: -428.27,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aM",
  x1: 1561.84,
  y1: -424.33,
  x2: 2315.69,
  y2: -424.33,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aN",
  x1: 1563.07,
  y1: -420.23,
  x2: 2322.72,
  y2: -420.23,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aO",
  x1: 1564.2,
  y1: -416.12,
  x2: 2329.65,
  y2: -416.12,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aP",
  x1: 1565.33,
  y1: -412.01,
  x2: 2336.57,
  y2: -412.01,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aQ",
  x1: 1566.56,
  y1: -408.11,
  x2: 2343.67,
  y2: -408.11,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aR",
  x1: 1567.69,
  y1: -404.1,
  x2: 2350.59,
  y2: -404.1,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aS",
  x1: 1568.92,
  y1: -400,
  x2: 2357.62,
  y2: -400,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aT",
  x1: 1570.05,
  y1: -395.8,
  x2: 2364.56,
  y2: -395.8,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aU",
  x1: 1571.18,
  y1: -391.64,
  x2: 2371.6,
  y2: -391.64,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aV",
  x1: 1572.41,
  y1: -387.75,
  x2: 2378.89,
  y2: -387.75,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aW",
  x1: 1573.54,
  y1: -383.64,
  x2: 2385.82,
  y2: -383.64,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aX",
  x1: 1574.77,
  y1: -379.54,
  x2: 2392.85,
  y2: -379.54,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aY",
  x1: 1575.9,
  y1: -375.43,
  x2: 2399.68,
  y2: -375.43,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__aZ",
  x1: 1577.13,
  y1: -371.54,
  x2: 2406.87,
  y2: -371.54,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__ba",
  x1: 1578.23,
  y1: -367.48,
  x2: 2413.83,
  y2: -367.48,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bb",
  x1: 1579.32,
  y1: -363.56,
  x2: 2420.46,
  y2: -363.56,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bc",
  x1: 1580.41,
  y1: -359.8,
  x2: 2427.37,
  y2: -359.8,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bd",
  x1: 1581.5,
  y1: -355.72,
  x2: 2434.02,
  y2: -355.72,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__be",
  x1: 1582.6,
  y1: -351.95,
  x2: 2440.63,
  y2: -351.95,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bf",
  x1: 1583.79,
  y1: -347.95,
  x2: 2447.67,
  y2: -347.95,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bg",
  x1: 1584.89,
  y1: -344.08,
  x2: 2454.3,
  y2: -344.08,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bh",
  x1: 1585.98,
  y1: -340.17,
  x2: 2461.23,
  y2: -340.17,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bi",
  x1: 1587.07,
  y1: -336.19,
  x2: 2467.87,
  y2: -336.19,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bj",
  x1: 1588.17,
  y1: -332.33,
  x2: 2474.59,
  y2: -332.33,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bk",
  x1: 1589.26,
  y1: -328.31,
  x2: 2481.44,
  y2: -328.31,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bl",
  x1: 1590.45,
  y1: -324.65,
  x2: 2488.13,
  y2: -324.65,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bm",
  x1: 1591.54,
  y1: -320.59,
  x2: 2495.09,
  y2: -320.59,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bn",
  x1: 1592.64,
  y1: -316.57,
  x2: 2501.74,
  y2: -316.57,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bo",
  x1: 1593.74,
  y1: -312.8,
  x2: 2508.44,
  y2: -312.8,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bp",
  x1: 1594.83,
  y1: -308.73,
  x2: 2515.29,
  y2: -308.73,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bq",
  x1: 1596.02,
  y1: -304.97,
  x2: 2522.01,
  y2: -304.97,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__br",
  x1: 1597.11,
  y1: -301.06,
  x2: 2528.93,
  y2: -301.06,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bs",
  x1: 1598.21,
  y1: -297.19,
  x2: 2535.56,
  y2: -297.19,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bt",
  x1: 1599.3,
  y1: -293.12,
  x2: 2542.41,
  y2: -293.12,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bu",
  x1: 1600.4,
  y1: -289.25,
  x2: 2549.13,
  y2: -289.25,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bv",
  x1: 1601.49,
  y1: -285.43,
  x2: 2555.75,
  y2: -285.43,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bw",
  x1: 1602.68,
  y1: -281.38,
  x2: 2562.81,
  y2: -281.38,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bx",
  x1: 1603.78,
  y1: -277.66,
  x2: 2569.4,
  y2: -277.66,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__by",
  x1: 1604.87,
  y1: -273.6,
  x2: 2576.36,
  y2: -273.6,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bz",
  x1: 1605.97,
  y1: -269.72,
  x2: 2582.98,
  y2: -269.72,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bA",
  x1: 1612.92,
  y1: -265.88,
  x2: 2583.34,
  y2: -265.88,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bB",
  x1: 1619.86,
  y1: -262.25,
  x2: 2583.77,
  y2: -262.25,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bC",
  x1: 1626.81,
  y1: -258.61,
  x2: 2584.2,
  y2: -258.61,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bD",
  x1: 1633.65,
  y1: -254.77,
  x2: 2584.76,
  y2: -254.77,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bE",
  x1: 1640.6,
  y1: -251.14,
  x2: 2585.39,
  y2: -251.14,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bF",
  x1: 1647.55,
  y1: -247.51,
  x2: 2585.91,
  y2: -247.51,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bG",
  x1: 1654.49,
  y1: -243.67,
  x2: 2586.38,
  y2: -243.67,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bH",
  x1: 1661.44,
  y1: -240.04,
  x2: 2587,
  y2: -240.04,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bI",
  x1: 1668.28,
  y1: -236.41,
  x2: 2587.53,
  y2: -236.41,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bJ",
  x1: 1675.23,
  y1: -232.78,
  x2: 2588.16,
  y2: -232.78,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bK",
  x1: 1682.18,
  y1: -228.94,
  x2: 2588.52,
  y2: -228.94,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bL",
  x1: 1689.12,
  y1: -225.31,
  x2: 2589.15,
  y2: -225.31,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bM",
  x1: 1696.07,
  y1: -221.63,
  x2: 2589.78,
  y2: -221.63,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bN",
  x1: 1703.02,
  y1: -217.7,
  x2: 2590.46,
  y2: -217.7,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bO",
  x1: 1709.86,
  y1: -214.05,
  x2: 2590.69,
  y2: -214.05,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bP",
  x1: 1716.81,
  y1: -210.42,
  x2: 2591.31,
  y2: -210.42,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bQ",
  x1: 1723.75,
  y1: -206.6,
  x2: 2591.98,
  y2: -206.6,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bR",
  x1: 1730.7,
  y1: -202.97,
  x2: 2592.6,
  y2: -202.97,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bS",
  x1: 1737.65,
  y1: -199.32,
  x2: 2592.93,
  y2: -199.32,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bT",
  x1: 1744.49,
  y1: -195.49,
  x2: 2593.49,
  y2: -195.49,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bU",
  x1: 1751.44,
  y1: -191.86,
  x2: 2594.12,
  y2: -191.86,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bV",
  x1: 1758.39,
  y1: -188.23,
  x2: 2594.75,
  y2: -188.23,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-splash-right_svg__bW",
  x1: 1765.33,
  y1: -184.59,
  x2: 2595.07,
  y2: -184.59,
  xlinkHref: "#bg-splash-right_svg__a"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg-splash-right_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M589.8 1.2h853.3v809H589.8z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg-splash-right_svg__b)",
  strokeMiterlimit: 10,
  strokeWidth: 0.8,
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1427.5-808.1c55.1 66.4 84.9 41.2 140.1 107.6s25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6",
  stroke: "url(#bg-splash-right_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.6-807.2c54.6 66.7 84.5 41.7 139.1 108.4s24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4 24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4 24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4",
  stroke: "url(#bg-splash-right_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425.8-806.3c54.1 67.1 84.1 42.1 138.2 109.3s24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3 24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3 24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3",
  stroke: "url(#bg-splash-right_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424.9-805.5c53.7 67.5 83.7 42.6 137.3 110.1s23.6 92.4 77.3 159.9 83.7 42.6 137.3 110.1 23.7 92.4 77.3 159.9 83.7 42.6 137.3 110.1 23.7 92.4 77.3 159.9 83.7 42.6 137.3 110.1",
  stroke: "url(#bg-splash-right_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424-804.6c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.5 83.2 43.1 136.4 111 23.1 92.7 76.3 160.6 83.2 43.1 136.4 111 23.1 92.7 76.3 160.6 83.2 43.1 136.4 111",
  stroke: "url(#bg-splash-right_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1423.1-803.7c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.2 161.2 82.8 43.5 135.5 111.8 22.6 93 75.3 161.2 82.8 43.5 135.5 111.8 22.6 93 75.3 161.2 82.8 43.5 135.5 111.8",
  stroke: "url(#bg-splash-right_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1422.2-802.9c52.2 68.6 82.4 44 134.6 112.6s22 93.3 74.2 161.9 82.4 44 134.6 112.6 22 93.3 74.2 161.9 82.4 44 134.6 112.6 22 93.3 74.2 161.9 82.4 44 134.6 112.7",
  stroke: "url(#bg-splash-right_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1421.4-802c51.7 69 82 44.5 133.7 113.5s21.5 93.6 73.2 162.6 82 44.5 133.7 113.5 21.5 93.6 73.2 162.6 82 44.5 133.7 113.5 21.5 93.6 73.2 162.6 82 44.5 133.7 113.5",
  stroke: "url(#bg-splash-right_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1420.5-801.1c51.2 69.4 81.5 44.9 132.8 114.3s20.9 93.9 72.2 163.3 81.5 44.9 132.8 114.3 20.9 93.9 72.2 163.3 81.5 44.9 132.8 114.3 20.9 93.9 72.2 163.3S2117 76.6 2168.3 146",
  stroke: "url(#bg-splash-right_svg__j)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1419.6-800.3c50.7 69.8 81.1 45.4 131.8 115.2s20.4 94.2 71.1 163.9 81.1 45.4 131.8 115.2 20.4 94.2 71.1 163.9 81.1 45.4 131.8 115.2 20.4 94.2 71.1 163.9 81.1 45.4 131.9 115.2",
  stroke: "url(#bg-splash-right_svg__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1418.7-799.4c50.3 70.2 80.7 45.9 130.9 116s19.8 94.5 70.1 164.6 80.7 45.9 130.9 116 19.9 94.5 70.1 164.6 80.7 45.9 130.9 116 19.9 94.5 70.1 164.6 80.7 45.9 130.9 116",
  stroke: "url(#bg-splash-right_svg__l)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1417.8-798.5c49.8 70.5 80.2 46.3 130 116.9s19.3 94.7 69.1 165.3 80.2 46.3 130 116.9 19.3 94.7 69.1 165.3 80.2 46.3 130 116.9 19.3 94.8 69.1 165.3 80.2 46.3 130 116.9",
  stroke: "url(#bg-splash-right_svg__m)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1417-797.7c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166 79.8 46.8 129.1 117.7 18.8 95 68.1 166 79.8 46.8 129.1 117.7 18.8 95 68.1 166 79.8 46.8 129.1 117.7",
  stroke: "url(#bg-splash-right_svg__n)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1416.1-796.8c48.8 71.3 79.4 47.3 128.2 118.6s18.2 95.3 67 166.6 79.4 47.3 128.2 118.6 18.2 95.3 67 166.6 79.4 47.3 128.2 118.6 18.2 95.3 67 166.7 79.4 47.3 128.2 118.6",
  stroke: "url(#bg-splash-right_svg__o)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1415.2-795.9c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3 79 47.7 127.3 119.4 17.7 95.6 66 167.3 79 47.7 127.3 119.4 17.7 95.6 66 167.3 79 47.7 127.3 119.4",
  stroke: "url(#bg-splash-right_svg__p)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1414.3-795.1c47.8 72.1 78.5 48.2 126.4 120.3s17.1 95.9 65 168 78.5 48.2 126.4 120.3 17.1 95.9 65 168 78.5 48.2 126.4 120.3 17.1 95.9 65 168 78.5 48.2 126.4 120.3",
  stroke: "url(#bg-splash-right_svg__q)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.4-794.2c47.4 72.4 78.1 48.7 125.5 121.1s16.6 96.2 63.9 168.7 78.1 48.7 125.5 121.1 16.6 96.2 63.9 168.7 78.1 48.7 125.5 121.1 16.6 96.2 64 168.7 78.1 48.7 125.5 121.1",
  stroke: "url(#bg-splash-right_svg__r)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1412.5-793.3c46.9 72.8 77.7 49.1 124.6 122s16.1 96.5 62.9 169.4 77.7 49.1 124.6 122 16.1 96.5 62.9 169.4 77.7 49.1 124.6 122S1928.2 8 1975 80.9s77.7 49.1 124.6 122",
  stroke: "url(#bg-splash-right_svg__s)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1411.7-792.5c46.4 73.2 77.3 49.6 123.6 122.8s15.5 96.8 61.9 170 77.3 49.6 123.6 122.8 15.5 96.8 61.9 170 77.3 49.6 123.6 122.8 15.5 96.8 61.9 170 77.3 49.6 123.6 122.8",
  stroke: "url(#bg-splash-right_svg__t)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1410.8-791.6c45.9 73.6 76.8 50.1 122.7 123.6s15 97.1 60.9 170.7 76.8 50.1 122.7 123.6 15 97.1 60.9 170.7 76.8 50.1 122.7 123.7 15 97.1 60.9 170.7 76.8 50.1 122.7 123.7",
  stroke: "url(#bg-splash-right_svg__u)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1409.9-790.7c45.4 74 76.4 50.5 121.8 124.5s14.4 97.4 59.8 171.4 76.4 50.5 121.8 124.5 14.4 97.4 59.8 171.4 76.4 50.5 121.8 124.5S1909.3 23 1954.7 97s76.4 50.5 121.8 124.5",
  stroke: "url(#bg-splash-right_svg__v)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1409-789.9c44.9 74.4 76 51 120.9 125.3s13.9 97.7 58.8 172.1 76 51 120.9 125.3 13.9 97.7 58.8 172.1 76 51 120.9 125.3 13.9 97.7 58.8 172.1 76 51 120.9 125.4",
  stroke: "url(#bg-splash-right_svg__w)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1408.1-789c44.4 74.7 75.6 51.5 120 126.2s13.3 98 57.8 172.7 75.6 51.5 120 126.2 13.3 98 57.8 172.7 75.6 51.5 120 126.2 13.3 98 57.8 172.7 75.6 51.5 120 126.2",
  stroke: "url(#bg-splash-right_svg__x)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1407.3-788.1c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4 75.1 51.9 119.1 127 12.8 98.3 56.8 173.4 75.1 51.9 119.1 127S1891 38 1935 113.1s75.1 51.9 119.1 127",
  stroke: "url(#bg-splash-right_svg__y)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.4-787.2c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9 12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9 12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9",
  stroke: "url(#bg-splash-right_svg__z)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1405.5-786.4c43 75.9 74.3 52.9 117.3 128.7s11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7 11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7 11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7",
  stroke: "url(#bg-splash-right_svg__A)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1404.6-785.5c42.5 76.3 73.8 53.3 116.4 129.6s11.2 99.2 53.7 175.4 73.8 53.3 116.4 129.6 11.2 99.2 53.7 175.5 73.8 53.3 116.4 129.6 11.2 99.2 53.7 175.5 73.8 53.3 116.4 129.6",
  stroke: "url(#bg-splash-right_svg__B)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1397-779.2c43 75.9 74.3 52.9 117.3 128.7s11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7 11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7 11.7 98.9 54.7 174.8 74.3 52.9 117.3 128.7",
  stroke: "url(#bg-splash-right_svg__C)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1389.4-772.9c43.5 75.5 74.7 52.4 118.2 127.9s12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9 12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9 12.3 98.6 55.7 174.1 74.7 52.4 118.2 127.9",
  stroke: "url(#bg-splash-right_svg__D)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1381.8-766.7c44 75.1 75.1 51.9 119.1 127s12.8 98.3 56.8 173.4 75.1 51.9 119.1 127 12.8 98.3 56.8 173.4 75.1 51.9 119.1 127 12.8 98.3 56.8 173.4 75.1 51.9 119.1 127",
  stroke: "url(#bg-splash-right_svg__E)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.2-760.4c44.4 74.7 75.6 51.5 120 126.2s13.3 98 57.8 172.7 75.6 51.5 120 126.2 13.3 98 57.8 172.7 75.6 51.5 120 126.2 13.3 98 57.8 172.7 75.6 51.5 120 126.2",
  stroke: "url(#bg-splash-right_svg__F)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1366.6-754.1c44.9 74.4 76 51 120.9 125.3s13.9 97.7 58.8 172.1 76 51 120.9 125.3 13.9 97.7 58.8 172.1 76 51 120.9 125.3 13.9 97.7 58.8 172.1 76 51 120.9 125.4",
  stroke: "url(#bg-splash-right_svg__G)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1359-747.8c45.4 74 76.4 50.5 121.8 124.5s14.4 97.4 59.8 171.4 76.4 50.5 121.8 124.5 14.4 97.4 59.8 171.4 76.4 50.5 121.8 124.5 14.4 97.4 59.8 171.4 76.4 50.5 121.8 124.5",
  stroke: "url(#bg-splash-right_svg__H)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1351.3-741.5c45.9 73.6 76.8 50.1 122.7 123.6s15 97.1 60.9 170.7 76.8 50.1 122.7 123.6 15 97.1 60.9 170.7 76.8 50.1 122.7 123.7 15 97.1 60.9 170.7 76.8 50.1 122.7 123.7",
  stroke: "url(#bg-splash-right_svg__I)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1343.7-735.2c46.4 73.2 77.3 49.6 123.6 122.8s15.5 96.8 61.9 170 77.3 49.6 123.6 122.8 15.5 96.8 61.9 170S1792-100 1838.3-26.8s15.5 96.8 61.9 170 77.3 49.6 123.6 122.8",
  stroke: "url(#bg-splash-right_svg__J)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1336.1-728.9c46.9 72.8 77.7 49.1 124.6 122s16.1 96.5 62.9 169.4 77.7 49.1 124.6 122 16.1 96.5 62.9 169.4 77.7 49.1 124.6 122 16.1 96.5 62.9 169.4 77.7 49.1 124.6 122",
  stroke: "url(#bg-splash-right_svg__K)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1328.5-722.6c47.4 72.4 78.1 48.7 125.5 121.1s16.6 96.2 63.9 168.7 78.1 48.7 125.5 121.1 16.6 96.2 63.9 168.7 78.1 48.7 125.5 121.1 16.6 96.2 64 168.7 78.1 48.7 125.5 121.1",
  stroke: "url(#bg-splash-right_svg__L)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1320.9-716.4c47.8 72.1 78.5 48.2 126.4 120.3s17.1 95.9 65 168 78.5 48.2 126.4 120.3 17.1 95.9 65 168 78.5 48.2 126.4 120.3 17.1 95.9 65 168 78.5 48.2 126.4 120.3",
  stroke: "url(#bg-splash-right_svg__M)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1313.3-710.1c48.3 71.7 79 47.7 127.3 119.4s17.7 95.6 66 167.3 79 47.7 127.3 119.4 17.7 95.6 66 167.3 79 47.7 127.3 119.4 17.7 95.6 66 167.3 79 47.7 127.3 119.4",
  stroke: "url(#bg-splash-right_svg__N)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1305.7-703.8c48.8 71.3 79.4 47.3 128.2 118.6s18.2 95.3 67 166.6 79.4 47.3 128.2 118.6 18.2 95.3 67 166.6 79.4 47.3 128.2 118.6 18.2 95.3 67 166.7 79.4 47.3 128.2 118.6",
  stroke: "url(#bg-splash-right_svg__O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1298.1-697.5c49.3 70.9 79.8 46.8 129.1 117.7s18.8 95 68.1 166 79.8 46.8 129.1 117.7 18.8 95 68.1 166 79.8 46.8 129.1 117.7 18.8 95 68.1 166 79.8 46.8 129.1 117.7",
  stroke: "url(#bg-splash-right_svg__P)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1290.5-691.2c49.8 70.5 80.2 46.3 130 116.9s19.3 94.7 69.1 165.3 80.2 46.3 130 116.9 19.3 94.7 69.1 165.3 80.2 46.3 130 116.9 19.3 94.8 69.1 165.3 80.2 46.3 130 116.9",
  stroke: "url(#bg-splash-right_svg__Q)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1282.9-684.9c50.3 70.2 80.7 45.9 130.9 116s19.8 94.5 70.1 164.6 80.7 45.9 130.9 116 19.9 94.5 70.1 164.6 80.7 45.9 130.9 116 19.9 94.5 70.1 164.6 80.7 45.9 130.9 116",
  stroke: "url(#bg-splash-right_svg__R)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1275.2-678.6c50.7 69.8 81.1 45.4 131.8 115.2s20.4 94.2 71.1 163.9 81.1 45.4 131.8 115.2 20.4 94.2 71.1 163.9c51 69.8 81.3 45.4 132.1 115.2s20.4 94.2 71.1 163.9 81.1 45.4 131.9 115.2",
  stroke: "url(#bg-splash-right_svg__S)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1267.6-672.4c51.2 69.4 81.5 44.9 132.8 114.3s20.9 93.9 72.2 163.3 81.5 44.9 132.8 114.3 20.9 93.9 72.2 163.3 81.5 44.9 132.8 114.3 20.9 93.9 72.2 163.3 81.5 44.9 132.8 114.3",
  stroke: "url(#bg-splash-right_svg__T)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1260-666.1c51.7 69 82 44.5 133.7 113.5s21.5 93.6 73.2 162.6 82 44.5 133.7 113.5 21.5 93.6 73.2 162.6 82 44.5 133.7 113.5 21.5 93.6 73.2 162.6 82 44.5 133.7 113.5",
  stroke: "url(#bg-splash-right_svg__U)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1252.4-659.8c52.2 68.6 82.4 44 134.6 112.6s22 93.3 74.2 161.9 82.4 44 134.6 112.6 22 93.3 74.2 161.9 82.4 44 134.6 112.6 22 93.3 74.2 161.9 82.4 44 134.6 112.7",
  stroke: "url(#bg-splash-right_svg__V)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1244.8-653.5c52.7 68.3 82.8 43.5 135.5 111.8s22.6 93 75.2 161.2 82.8 43.5 135.5 111.8 22.6 93 75.3 161.2S1749.1-64 1801.8 4.3s22.6 93 75.3 161.2 82.8 43.5 135.5 111.8",
  stroke: "url(#bg-splash-right_svg__W)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1237.2-647.2c53.2 67.9 83.2 43.1 136.4 111s23.1 92.7 76.3 160.5 83.2 43.1 136.4 111 23.1 92.7 76.3 160.6S1745.8-61 1799 6.9s23.1 92.7 76.3 160.6 83.2 43.1 136.4 111",
  stroke: "url(#bg-splash-right_svg__X)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1229.6-640.9c53.7 67.5 83.7 42.6 137.3 110.1s23.6 92.4 77.3 159.9 83.7 42.6 137.3 110.1 23.6 92.4 77.3 159.9 83.7 42.6 137.3 110.1 23.7 92.4 77.3 159.9 83.7 42.6 137.3 110.1",
  stroke: "url(#bg-splash-right_svg__Y)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1222-634.6c54.1 67.1 84.1 42.1 138.2 109.3s24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3 24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3 24.2 92.1 78.3 159.2 84.1 42.1 138.2 109.3",
  stroke: "url(#bg-splash-right_svg__Z)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1214.4-628.4c54.6 66.7 84.5 41.7 139.1 108.4s24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4 24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4 24.7 91.8 79.4 158.5 84.5 41.7 139.1 108.4",
  stroke: "url(#bg-splash-right_svg__aa)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1206.8-622.1c55.1 66.4 84.9 41.2 140.1 107.6s25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6",
  stroke: "url(#bg-splash-right_svg__ab)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1199.4-615.7c55.5 66 85.3 40.8 140.8 106.7s25.8 91.2 81.3 157.1 85.3 40.8 140.8 106.7 25.8 91.2 81.3 157.2 85.3 40.8 140.8 106.7 25.8 91.2 81.3 157.2 85.3 40.8 140.8 106.7",
  stroke: "url(#bg-splash-right_svg__ac)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1192.1-609.3c56 65.6 85.7 40.3 141.6 105.9s26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9 26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9 26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9",
  stroke: "url(#bg-splash-right_svg__ad)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1184.8-602.9c56.4 65.2 86 39.9 142.4 105.1s26.7 90.6 83.1 155.8 86 39.9 142.4 105.1 26.7 90.6 83.1 155.8 86 39.9 142.4 105.1 26.7 90.6 83.1 155.8 86 39.9 142.4 105.1",
  stroke: "url(#bg-splash-right_svg__ae)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1177.4-596.5c56.8 64.8 86.4 39.4 143.2 104.3s27.2 90.2 84 155.1 86.4 39.4 143.2 104.3 27.2 90.2 84 155.1 86.4 39.4 143.2 104.3 27.2 90.2 84 155.1 86.4 39.4 143.2 104.3",
  stroke: "url(#bg-splash-right_svg__af)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1170.1-590.1c57.2 64.5 86.7 39 143.9 103.4s27.7 89.9 84.9 154.4 86.7 39 143.9 103.4 27.7 89.9 84.9 154.4 86.7 39 143.9 103.4 27.7 89.9 84.9 154.4 86.7 39 143.9 103.5",
  stroke: "url(#bg-splash-right_svg__ag)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1162.7-583.7c57.6 64.1 87.1 38.5 144.7 102.6s28.2 89.6 85.8 153.7 87.1 38.5 144.7 102.6 28.2 89.6 85.8 153.7 87.1 38.5 144.7 102.6 28.2 89.6 85.9 153.7 87.1 38.5 144.7 102.6",
  stroke: "url(#bg-splash-right_svg__ah)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1155.4-577.3c58.1 63.7 87.4 38.1 145.5 101.8s28.7 89.3 86.8 153 87.4 38.1 145.5 101.8 28.7 89.3 86.8 153 87.4 38.1 145.5 101.8 28.7 89.3 86.8 153 87.4 38.1 145.5 101.8",
  stroke: "url(#bg-splash-right_svg__ai)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1148.1-570.9c58.5 63.3 87.8 37.7 146.3 101s29.2 89 87.7 152.3 87.8 37.7 146.3 101 29.2 89 87.7 152.3 87.8 37.7 146.3 101 29.2 89 87.7 152.3 87.8 37.7 146.3 101",
  stroke: "url(#bg-splash-right_svg__aj)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1140.7-564.5c58.9 62.9 88.1 37.2 147.1 100.2s29.7 88.7 88.6 151.6 88.1 37.2 147.1 100.2 29.7 88.7 88.6 151.6 88.1 37.2 147.1 100.2 29.7 88.7 88.6 151.6 88.2 37.2 147.1 100.2",
  stroke: "url(#bg-splash-right_svg__ak)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1133.4-558.1c59.3 62.6 88.5 36.8 147.8 99.3s30.2 88.4 89.5 151 88.5 36.8 147.8 99.3 30.2 88.4 89.5 151 88.5 36.8 147.8 99.3 30.2 88.4 89.5 151 88.5 36.8 147.8 99.3",
  stroke: "url(#bg-splash-right_svg__al)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.1-551.7c59.8 62.2 88.9 36.3 148.6 98.5s30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5 30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5 30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5",
  stroke: "url(#bg-splash-right_svg__am)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118.7-545.3c60.2 61.8 89.2 35.9 149.4 97.7s31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7 31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7 31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7",
  stroke: "url(#bg-splash-right_svg__an)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1111.4-538.9c60.6 61.4 89.6 35.4 150.2 96.9s31.6 87.4 92.2 148.9 89.6 35.4 150.2 96.9 31.6 87.4 92.2 148.9 89.6 35.4 150.2 96.9 31.6 87.5 92.2 148.9 89.6 35.4 150.2 96.9",
  stroke: "url(#bg-splash-right_svg__ao)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1104-532.5c61 61.1 89.9 35 150.9 96s32.1 87.1 93.1 148.2 89.9 35 150.9 96 32.1 87.1 93.1 148.2 89.9 35 150.9 96S1775 139 1836 200.1s89.9 35 151 96",
  stroke: "url(#bg-splash-right_svg__ap)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1096.7-526.1c61.4 60.7 90.3 34.5 151.7 95.2s32.6 86.8 94 147.5 90.3 34.5 151.7 95.2 32.6 86.8 94 147.5 90.3 34.5 151.7 95.2 32.6 86.8 94 147.5 90.3 34.5 151.7 95.2",
  stroke: "url(#bg-splash-right_svg__aq)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1089.4-519.7c61.9 60.3 90.6 34.1 152.5 94.4s33.1 86.5 94.9 146.8 90.6 34.1 152.5 94.4 33.1 86.5 94.9 146.8 90.6 34.1 152.5 94.4 33.1 86.5 95 146.8 90.6 34.1 152.5 94.4",
  stroke: "url(#bg-splash-right_svg__ar)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1082-513.3c62.3 59.9 91 33.6 153.3 93.6s33.6 86.2 95.9 146.1 91 33.6 153.3 93.6 33.6 86.2 95.9 146.1 91 33.6 153.3 93.6 33.6 86.2 95.9 146.1 91 33.6 153.3 93.6",
  stroke: "url(#bg-splash-right_svg__as)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.7-506.9c62.7 59.5 91.4 33.2 154.1 92.7s34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.7 34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.7 34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.8",
  stroke: "url(#bg-splash-right_svg__at)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1067.4-500.5c63.1 59.2 91.7 32.8 154.8 91.9s34.5 85.6 97.7 144.8 91.7 32.8 154.8 91.9 34.5 85.6 97.7 144.8 91.7 32.8 154.8 91.9 34.6 85.6 97.7 144.8 91.7 32.8 154.8 91.9",
  stroke: "url(#bg-splash-right_svg__au)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1060-494.1c63.6 58.8 92.1 32.3 155.6 91.1s35 85.3 98.6 144.1 92.1 32.3 155.6 91.1 35 85.3 98.6 144.1 92.1 32.3 155.6 91.1 35 85.3 98.6 144.1 92.1 32.3 155.6 91.1",
  stroke: "url(#bg-splash-right_svg__av)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1052.7-487.7c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4 92.4 31.9 156.4 90.3 35.5 85 99.5 143.4 92.4 31.9 156.4 90.3 35.5 85 99.5 143.4 92.4 31.9 156.4 90.3",
  stroke: "url(#bg-splash-right_svg__aw)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1045.4-481.3c64.4 58 92.8 31.4 157.2 89.5s36 84.7 100.4 142.7 92.8 31.4 157.2 89.5 36 84.7 100.4 142.7 92.8 31.4 157.2 89.5 36 84.7 100.4 142.7 92.8 31.4 157.2 89.5",
  stroke: "url(#bg-splash-right_svg__ax)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1038-474.9c64.8 57.7 93.1 31 158 88.6s36.5 84.3 101.3 142 93.1 31 158 88.6 36.5 84.3 101.3 142 93.1 31 158 88.6 36.5 84.3 101.3 142 93.1 31 158 88.6",
  stroke: "url(#bg-splash-right_svg__ay)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1030.7-468.5c65.2 57.3 93.5 30.5 158.7 87.8s37 84 102.2 141.3 93.5 30.5 158.7 87.8 37 84 102.2 141.3 93.5 30.5 158.7 87.8 37 84 102.2 141.3 93.5 30.5 158.7 87.8",
  stroke: "url(#bg-splash-right_svg__az)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1023.3-462.1c65.7 56.9 93.8 30.1 159.5 87s37.5 83.7 103.1 140.6 93.8 30.1 159.5 87 37.5 83.7 103.1 140.6 93.8 30.1 159.5 87 37.5 83.7 103.1 140.6 93.9 30.1 159.5 87",
  stroke: "url(#bg-splash-right_svg__aA)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.8-461c65.2 57.3 93.5 30.5 158.7 87.8s37 84 102.2 141.3 93.5 30.5 158.7 87.8 37 84 102.2 141.3 93.5 30.5 158.7 87.8 37 84 102.2 141.3 93.5 30.5 158.7 87.8",
  stroke: "url(#bg-splash-right_svg__aB)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1020.4-460c64.8 57.7 93.1 31 158 88.6s36.5 84.3 101.3 142 93.1 31 158 88.6 36.5 84.3 101.3 142 93.1 31 158 88.6 36.5 84.3 101.3 142 93.1 31 158 88.6",
  stroke: "url(#bg-splash-right_svg__aC)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1018.9-459c64.4 58 92.8 31.4 157.2 89.5s36 84.7 100.4 142.7 92.8 31.4 157.2 89.5 36 84.7 100.4 142.7 92.8 31.4 157.2 89.5 36 84.7 100.4 142.7 92.8 31.4 157.2 89.5",
  stroke: "url(#bg-splash-right_svg__aD)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1017.4-457.9c64 58.4 92.4 31.9 156.4 90.3s35.5 85 99.5 143.4 92.4 31.9 156.4 90.3 35.5 85 99.5 143.4 92.4 31.9 156.4 90.3 35.5 85 99.5 143.4 92.4 31.9 156.4 90.3",
  stroke: "url(#bg-splash-right_svg__aE)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1015.9-456.9c63.6 58.8 92.1 32.3 155.6 91.1s35 85.3 98.6 144.1 92.1 32.3 155.6 91.1 35 85.3 98.6 144.1 92.1 32.3 155.6 91.1 35 85.3 98.6 144.1 92.1 32.3 155.6 91.1",
  stroke: "url(#bg-splash-right_svg__aF)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.4-455.8c63.1 59.2 91.7 32.8 154.8 91.9s34.5 85.6 97.7 144.8 91.7 32.8 154.8 91.9 34.5 85.6 97.7 144.8 91.7 32.8 154.8 91.9 34.6 85.6 97.7 144.8 91.7 32.8 154.8 91.9",
  stroke: "url(#bg-splash-right_svg__aG)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1012.9-454.8c62.7 59.5 91.4 33.2 154.1 92.7s34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.7 34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.7 34.1 85.9 96.8 145.4 91.4 33.2 154.1 92.8",
  stroke: "url(#bg-splash-right_svg__aH)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1011.4-453.7c62.3 59.9 91 33.6 153.3 93.6s33.6 86.2 95.9 146.1 91 33.6 153.3 93.6 33.6 86.2 95.9 146.1 91 33.6 153.3 93.6 33.6 86.2 95.9 146.1 91 33.6 153.3 93.6",
  stroke: "url(#bg-splash-right_svg__aI)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1009.9-452.7c61.9 60.3 90.6 34.1 152.5 94.4s33.1 86.5 94.9 146.8 90.6 34.1 152.5 94.4 33.1 86.5 94.9 146.8 90.6 34.1 152.5 94.4 33.1 86.5 95 146.8 90.6 34.1 152.5 94.4",
  stroke: "url(#bg-splash-right_svg__aJ)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.4-451.7c61.4 60.7 90.3 34.5 151.7 95.2s32.6 86.8 94 147.5 90.3 34.5 151.7 95.2 32.6 86.8 94 147.5 90.3 34.5 151.7 95.2 32.6 86.8 94 147.5 90.3 34.5 151.7 95.2",
  stroke: "url(#bg-splash-right_svg__aK)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1006.9-450.6c61 61.1 89.9 35 150.9 96s32.1 87.1 93.1 148.2 89.9 35 150.9 96 32.1 87.1 93.1 148.2 89.9 35 150.9 96 32.1 87.1 93.1 148.2 89.9 35 151 96",
  stroke: "url(#bg-splash-right_svg__aL)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1005.4-449.6c60.6 61.4 89.6 35.4 150.2 96.9s31.6 87.4 92.2 148.9 89.6 35.4 150.2 96.9 31.6 87.4 92.2 148.9 89.6 35.4 150.2 96.9 31.6 87.5 92.2 148.9 89.6 35.4 150.2 96.9",
  stroke: "url(#bg-splash-right_svg__aM)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1003.9-448.5c60.2 61.8 89.2 35.9 149.4 97.7s31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7 31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7 31.1 87.8 91.3 149.6 89.2 35.9 149.4 97.7",
  stroke: "url(#bg-splash-right_svg__aN)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1002.4-447.5c59.8 62.2 88.9 36.3 148.6 98.5s30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5 30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5 30.6 88.1 90.4 150.3 88.9 36.3 148.6 98.5",
  stroke: "url(#bg-splash-right_svg__aO)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1000.9-446.5c59.3 62.6 88.5 36.8 147.8 99.3s30.2 88.4 89.5 151 88.5 36.8 147.8 99.3 30.2 88.4 89.5 151 88.5 36.8 147.8 99.3 30.2 88.4 89.5 151 88.5 36.8 147.8 99.3",
  stroke: "url(#bg-splash-right_svg__aP)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M999.4-445.4c58.9 62.9 88.1 37.2 147.1 100.2s29.7 88.7 88.6 151.6 88.1 37.2 147.1 100.2 29.7 88.7 88.6 151.6 88.1 37.2 147.1 100.2 29.7 88.7 88.6 151.6 88.2 37.2 147.1 100.2",
  stroke: "url(#bg-splash-right_svg__aQ)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M998-444.4c58.5 63.3 87.8 37.7 146.3 101s29.2 89 87.7 152.3 87.8 37.7 146.3 101 29.2 89 87.7 152.3 87.8 37.7 146.3 101 29.2 89 87.7 152.3 87.8 37.7 146.3 101",
  stroke: "url(#bg-splash-right_svg__aR)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M996.5-443.3c58.1 63.7 87.4 38.1 145.5 101.8s28.7 89.3 86.8 153 87.4 38.1 145.5 101.8 28.7 89.3 86.8 153 87.4 38.1 145.5 101.8 28.7 89.3 86.8 153 87.4 38.1 145.5 101.8",
  stroke: "url(#bg-splash-right_svg__aS)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995-442.3c57.6 64.1 87.1 38.5 144.7 102.6s28.2 89.6 85.8 153.7 87.1 38.5 144.7 102.6 28.2 89.6 85.8 153.7 87.1 38.5 144.7 102.6 28.2 89.6 85.9 153.7 87.1 38.5 144.7 102.6",
  stroke: "url(#bg-splash-right_svg__aT)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M993.5-441.3c57.2 64.5 86.7 39 143.9 103.4s27.7 89.9 84.9 154.4 86.7 39 143.9 103.4 27.7 89.9 84.9 154.4 86.7 39 143.9 103.4 27.7 89.9 84.9 154.4 86.7 39 143.9 103.5",
  stroke: "url(#bg-splash-right_svg__aU)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M992-440.2c56.8 64.8 86.4 39.4 143.2 104.3s27.2 90.2 84 155.1 86.4 39.4 143.2 104.3 27.2 90.2 84 155.1 86.4 39.4 143.2 104.3 27.2 90.2 84 155.1 86.4 39.4 143.2 104.3",
  stroke: "url(#bg-splash-right_svg__aV)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M990.5-439.2c56.4 65.2 86 39.9 142.4 105.1s26.7 90.6 83.1 155.8 86 39.9 142.4 105.1 26.7 90.6 83.1 155.8 86 39.9 142.4 105.1 26.7 90.6 83.1 155.8 86 39.9 142.4 105.1",
  stroke: "url(#bg-splash-right_svg__aW)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M989-438.1c56 65.6 85.7 40.3 141.6 105.9s26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9 26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9 26.3 90.9 82.2 156.5 85.7 40.3 141.6 105.9",
  stroke: "url(#bg-splash-right_svg__aX)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M987.5-437.1c55.5 66 85.3 40.8 140.8 106.7s25.8 91.2 81.3 157.1 85.3 40.8 140.8 106.7 25.8 91.2 81.3 157.2 85.3 40.8 140.8 106.7 25.8 91.2 81.3 157.2 85.3 40.8 140.8 106.7",
  stroke: "url(#bg-splash-right_svg__aY)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M986-436c55.1 66.4 84.9 41.2 140.1 107.6s25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6",
  stroke: "url(#bg-splash-right_svg__aZ)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M984.9-435c54.7 66.7 84.5 41.7 139.2 108.4s24.8 91.8 79.4 158.5 84.5 41.7 139.2 108.4 24.8 91.8 79.4 158.5 84.5 41.7 139.2 108.4 24.8 91.8 79.4 158.5 84.5 41.7 139.2 108.4",
  stroke: "url(#bg-splash-right_svg__ba)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M983.8-434c54.2 67.1 84.1 42.1 138.3 109.2s24.3 92 78.5 159.1 84.1 42.1 138.3 109.2 24.3 92.1 78.5 159.1 84.1 42.1 138.3 109.2 24.3 92.1 78.5 159.1 84.1 42.1 138.3 109.2",
  stroke: "url(#bg-splash-right_svg__bb)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.8-433c53.7 67.4 83.7 42.5 137.5 110s23.7 92.3 77.5 159.8 83.7 42.5 137.5 110 23.7 92.3 77.5 159.8 83.7 42.5 137.5 110 23.7 92.3 77.5 159.8 83.7 42.5 137.5 110",
  stroke: "url(#bg-splash-right_svg__bc)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M981.7-432c53.3 67.8 83.3 43 136.6 110.8s23.2 92.6 76.5 160.4 83.3 43 136.6 110.8 23.2 92.6 76.5 160.4 83.3 43 136.6 110.8 23.2 92.6 76.5 160.4 83.3 43 136.6 110.8",
  stroke: "url(#bg-splash-right_svg__bd)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M980.6-431c52.8 68.2 82.9 43.4 135.8 111.6s22.7 92.9 75.5 161 82.9 43.4 135.8 111.6 22.7 92.9 75.6 161 82.9 43.4 135.8 111.6 22.7 92.9 75.6 161 82.9 43.4 135.8 111.6",
  stroke: "url(#bg-splash-right_svg__be)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M979.5-429.9c52.4 68.5 82.5 43.9 134.9 112.4s22.2 93.2 74.6 161.7 82.5 43.9 134.9 112.4 22.2 93.2 74.6 161.7 82.5 43.9 134.9 112.4 22.2 93.2 74.6 161.7 82.5 43.9 134.9 112.4",
  stroke: "url(#bg-splash-right_svg__bf)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M978.4-428.9c51.9 68.9 82.1 44.3 134.1 113.2s21.7 93.5 73.6 162.3 82.1 44.3 134.1 113.2 21.7 93.5 73.6 162.3 82.1 44.3 134.1 113.2 21.7 93.5 73.6 162.3 82.1 44.3 134.1 113.2",
  stroke: "url(#bg-splash-right_svg__bg)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M977.4-427.9c51.5 69.2 81.7 44.7 133.2 114s21.2 93.7 72.6 163 81.7 44.7 133.2 114 21.2 93.7 72.6 163 81.7 44.7 133.2 114 21.2 93.7 72.7 163 81.7 44.7 133.2 114",
  stroke: "url(#bg-splash-right_svg__bh)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M976.3-426.9c51 69.6 81.3 45.2 132.3 114.8s20.7 94 71.7 163.6 81.3 45.2 132.3 114.8 20.7 94 71.7 163.6 81.3 45.2 132.3 114.8 20.7 94 71.7 163.6 81.3 45.2 132.3 114.8",
  stroke: "url(#bg-splash-right_svg__bi)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M975.2-425.9c50.5 70 80.9 45.6 131.5 115.6s20.2 94.3 70.7 164.2 80.9 45.6 131.5 115.6 20.2 94.3 70.7 164.2 80.9 45.6 131.5 115.6 20.2 94.3 70.7 164.3 80.9 45.6 131.5 115.6",
  stroke: "url(#bg-splash-right_svg__bj)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M974.1-424.9c50.1 70.3 80.5 46 130.6 116.4s19.7 94.6 69.7 164.9 80.5 46 130.6 116.4 19.7 94.6 69.7 164.9 80.5 46 130.6 116.4 19.7 94.6 69.8 164.9 80.5 46.1 130.6 116.4",
  stroke: "url(#bg-splash-right_svg__bk)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M973.1-423.8c49.6 70.7 80.1 46.5 129.8 117.2s19.1 94.9 68.8 165.5 80.1 46.5 129.8 117.2 19.1 94.9 68.8 165.5 80.1 46.5 129.8 117.2 19.1 94.9 68.8 165.5 80.1 46.5 129.8 117.2",
  stroke: "url(#bg-splash-right_svg__bl)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M972-422.8c49.2 71 79.7 46.9 128.9 118s18.6 95.1 67.8 166.2 79.7 46.9 128.9 118 18.6 95.1 67.8 166.2 79.7 46.9 128.9 118 18.6 95.1 67.8 166.2 79.7 46.9 128.9 118",
  stroke: "url(#bg-splash-right_svg__bm)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M970.9-421.8c48.7 71.4 79.3 47.4 128 118.8s18.1 95.4 66.8 166.8 79.3 47.4 128 118.8 18.1 95.4 66.8 166.8 79.3 47.4 128 118.8 18.1 95.4 66.8 166.8 79.3 47.4 128.1 118.8",
  stroke: "url(#bg-splash-right_svg__bn)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.8-420.8c48.3 71.8 78.9 47.8 127.2 119.6s17.6 95.7 65.9 167.4 78.9 47.8 127.2 119.6 17.6 95.7 65.9 167.4 78.9 47.8 127.2 119.6 17.6 95.7 65.9 167.5 78.9 47.8 127.2 119.6",
  stroke: "url(#bg-splash-right_svg__bo)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M968.7-419.8c47.8 72.1 78.5 48.2 126.3 120.4s17.1 96 64.9 168.1 78.5 48.2 126.3 120.4 17.1 96 64.9 168.1 78.5 48.2 126.3 120.4 17.1 96 64.9 168.1 78.5 48.2 126.3 120.4",
  stroke: "url(#bg-splash-right_svg__bp)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M967.7-418.7c47.4 72.5 78.1 48.7 125.5 121.2s16.6 96.3 63.9 168.7 78.1 48.7 125.5 121.2 16.6 96.3 63.9 168.7 78.1 48.7 125.5 121.2 16.6 96.3 63.9 168.7 78.1 48.7 125.5 121.2",
  stroke: "url(#bg-splash-right_svg__bq)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M966.6-417.7c46.9 72.8 77.7 49.1 124.6 122s16.1 96.5 63 169.4 77.7 49.1 124.6 122 16.1 96.5 63 169.4 77.7 49.1 124.6 122 16.1 96.5 63 169.4 77.7 49.1 124.6 122",
  stroke: "url(#bg-splash-right_svg__br)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5-416.7c46.4 73.2 77.3 49.6 123.8 122.8s15.6 96.8 62 170 77.3 49.6 123.8 122.8 15.6 96.8 62 170 77.3 49.6 123.8 122.8 15.6 96.8 62 170 77.3 49.6 123.8 122.8",
  stroke: "url(#bg-splash-right_svg__bs)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M964.4-415.7c46 73.6 76.9 50 122.9 123.6s15.1 97.1 61 170.6 76.9 50 122.9 123.6 15.1 97.1 61 170.7 76.9 50 122.9 123.6 15.1 97.1 61 170.7 76.9 50 122.9 123.6",
  stroke: "url(#bg-splash-right_svg__bt)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M963.3-414.7c45.5 73.9 76.5 50.4 122 124.4s14.5 97.4 60.1 171.3 76.5 50.4 122 124.4 14.5 97.4 60.1 171.3 76.5 50.4 122 124.4 14.5 97.4 60.1 171.3 76.5 50.4 122.1 124.4",
  stroke: "url(#bg-splash-right_svg__bu)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M962.3-413.7c45.1 74.3 76.1 50.9 121.2 125.2s14 97.7 59.1 171.9 76.1 50.9 121.2 125.2 14 97.7 59.1 171.9 76.1 50.9 121.2 125.2 14 97.7 59.1 171.9 76.1 50.9 121.2 125.2",
  stroke: "url(#bg-splash-right_svg__bv)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M961.2-412.6c44.6 74.6 75.7 51.3 120.3 126s13.5 97.9 58.1 172.6 75.7 51.3 120.3 126 13.5 97.9 58.1 172.6 75.7 51.3 120.3 126 13.5 97.9 58.1 172.6 75.7 51.3 120.3 126",
  stroke: "url(#bg-splash-right_svg__bw)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M960.1-411.6c44.2 75 75.3 51.8 119.5 126.8s13 98.2 57.2 173.2 75.3 51.8 119.5 126.8 13 98.2 57.2 173.2 75.3 51.8 119.5 126.8 13 98.2 57.2 173.2 75.3 51.8 119.5 126.8",
  stroke: "url(#bg-splash-right_svg__bx)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M959-410.6c43.7 75.4 74.9 52.2 118.6 127.6s12.5 98.5 56.2 173.9 74.9 52.2 118.6 127.6 12.5 98.5 56.2 173.9 74.9 52.2 118.6 127.6 12.5 98.5 56.2 173.9 74.9 52.2 118.6 127.6",
  stroke: "url(#bg-splash-right_svg__by)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M957.9-409.6c43.2 75.7 74.5 52.6 117.8 128.4s12 98.8 55.2 174.5 74.5 52.6 117.8 128.4 12 98.8 55.2 174.5 74.5 52.6 117.8 128.4 12 98.8 55.2 174.5 74.5 52.6 117.8 128.4",
  stroke: "url(#bg-splash-right_svg__bz)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M950.3-403.3c43.8 75.3 75 52.1 118.7 127.4s12.6 98.5 56.3 173.8 75 52.1 118.7 127.4 12.6 98.5 56.3 173.8 75 52.1 118.7 127.4 12.6 98.5 56.3 173.8 75 52.1 118.7 127.5",
  stroke: "url(#bg-splash-right_svg__bA)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.7-397c44.3 74.9 75.4 51.6 119.7 126.5s13.1 98.1 57.4 173 75.4 51.6 119.7 126.5 13.1 98.1 57.4 173 75.4 51.6 119.7 126.5 13.1 98.2 57.4 173.1 75.4 51.6 119.7 126.6",
  stroke: "url(#bg-splash-right_svg__bB)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M935.1-390.7c44.8 74.5 75.9 51.1 120.7 125.6s13.7 97.8 58.5 172.3 75.9 51.1 120.7 125.6 13.7 97.8 58.5 172.3 75.9 51.1 120.7 125.6 13.7 97.8 58.5 172.3 75.9 51.2 120.7 125.6",
  stroke: "url(#bg-splash-right_svg__bC)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M927.5-384.5c45.3 74.1 76.3 50.7 121.6 124.7s14.3 97.5 59.6 171.6 76.3 50.7 121.6 124.7 14.3 97.5 59.6 171.6 76.3 50.7 121.6 124.7 14.3 97.5 59.6 171.6 76.3 50.7 121.6 124.7",
  stroke: "url(#bg-splash-right_svg__bD)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M919.9-378.2c45.8 73.7 76.8 50.2 122.6 123.8s14.9 97.2 60.7 170.9 76.8 50.2 122.6 123.8 14.9 97.2 60.7 170.9 76.8 50.2 122.6 123.8 14.9 97.2 60.7 170.9 76.8 50.2 122.6 123.8",
  stroke: "url(#bg-splash-right_svg__bE)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M912.3-371.9c46.3 73.3 77.2 49.7 123.6 122.9s15.5 96.9 61.8 170.1 77.2 49.7 123.6 122.9 15.5 96.9 61.8 170.2 77.2 49.7 123.6 122.9 15.5 96.9 61.8 170.2 77.2 49.7 123.6 122.9",
  stroke: "url(#bg-splash-right_svg__bF)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.7-365.6c46.9 72.9 77.7 49.2 124.5 122s16 96.6 62.9 169.4 77.7 49.2 124.5 122 16 96.6 62.9 169.4 77.7 49.2 124.5 122 16 96.6 62.9 169.4 77.7 49.2 124.5 122",
  stroke: "url(#bg-splash-right_svg__bG)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M897.1-359.3c47.4 72.5 78.1 48.7 125.5 121.1s16.6 96.2 64 168.7 78.1 48.7 125.5 121.1 16.6 96.2 64 168.7 78.1 48.7 125.5 121.1 16.6 96.2 64 168.7 78.1 48.7 125.5 121.1",
  stroke: "url(#bg-splash-right_svg__bH)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M889.5-353.1c47.9 72 78.6 48.2 126.5 120.2s17.2 95.9 65.1 168 78.6 48.2 126.5 120.2 17.2 95.9 65.1 168 78.6 48.2 126.5 120.2 17.2 95.9 65.1 168 78.6 48.2 126.5 120.2",
  stroke: "url(#bg-splash-right_svg__bI)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M881.9-346.8c48.4 71.6 79 47.7 127.5 119.3s17.8 95.6 66.2 167.3 79 47.7 127.5 119.3 17.8 95.6 66.2 167.3 79 47.7 127.5 119.3 17.8 95.6 66.2 167.3 79 47.7 127.5 119.3",
  stroke: "url(#bg-splash-right_svg__bJ)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M874.3-340.5c48.9 71.2 79.5 47.2 128.4 118.4s18.3 95.3 67.3 166.5 79.5 47.2 128.4 118.4 18.3 95.3 67.3 166.5 79.5 47.2 128.4 118.4 18.3 95.3 67.3 166.5 79.5 47.2 128.4 118.4",
  stroke: "url(#bg-splash-right_svg__bK)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M866.7-334.2c49.4 70.8 80 46.7 129.4 117.5s18.9 95 68.4 165.8 80 46.7 129.4 117.5 18.9 95 68.4 165.8 80 46.7 129.4 117.5 18.9 95 68.4 165.8 80 46.7 129.4 117.5",
  stroke: "url(#bg-splash-right_svg__bL)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M859.1-327.9c50 70.4 80.4 46.2 130.4 116.6s19.5 94.7 69.4 165.1S1139.3 0 1189.3 70.4s19.5 94.7 69.5 165.1 80.4 46.2 130.4 116.6 19.5 94.7 69.5 165.1 80.4 46.2 130.4 116.6",
  stroke: "url(#bg-splash-right_svg__bM)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.5-321.6c50.5 70 80.9 45.7 131.3 115.7s20.1 94.3 70.5 164.4 80.9 45.7 131.3 115.7 20.1 94.3 70.5 164.4 80.9 45.7 131.3 115.7 20.1 94.3 70.5 164.4 80.9 45.7 131.3 115.7",
  stroke: "url(#bg-splash-right_svg__bN)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M843.9-315.4c51 69.6 81.3 45.2 132.3 114.8s20.7 94 71.6 163.6 81.3 45.2 132.3 114.8 20.7 94 71.6 163.6 81.3 45.2 132.3 114.8 20.7 94 71.6 163.6 81.3 45.2 132.3 114.8",
  stroke: "url(#bg-splash-right_svg__bO)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M836.3-309.1c51.5 69.2 81.8 44.7 133.3 113.9s21.2 93.7 72.7 162.9 81.8 44.7 133.3 113.9 21.2 93.7 72.7 162.9 81.8 44.7 133.3 113.9 21.2 93.7 72.7 162.9 81.8 44.7 133.3 113.9",
  stroke: "url(#bg-splash-right_svg__bP)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M828.7-302.8c52 68.8 82.2 44.2 134.2 113s21.8 93.4 73.8 162.2 82.2 44.2 134.2 113 21.8 93.4 73.8 162.2 82.2 44.2 134.2 113 21.8 93.4 73.8 162.2 82.2 44.2 134.2 113",
  stroke: "url(#bg-splash-right_svg__bQ)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M821.1-296.5c52.5 68.4 82.7 43.7 135.2 112.1s22.4 93.1 74.9 161.5 82.7 43.7 135.2 112.1 22.4 93.1 74.9 161.5 82.7 43.7 135.2 112.1 22.4 93.1 74.9 161.5 82.7 43.7 135.2 112.1",
  stroke: "url(#bg-splash-right_svg__bR)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.5-290.2c53 68 83.1 43.2 136.2 111.2s23 92.8 76 160.7 83.1 43.2 136.2 111.2 23 92.8 76 160.7 83.1 43.2 136.2 111.2 23 92.8 76 160.7 83.1 43.2 136.2 111.2",
  stroke: "url(#bg-splash-right_svg__bS)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805.9-284c53.6 67.6 83.6 42.7 137.1 110.3s23.5 92.4 77.1 160 83.6 42.7 137.1 110.3 23.5 92.4 77.1 160 83.6 42.7 137.1 110.3 23.5 92.4 77.1 160 83.6 42.7 137.1 110.3",
  stroke: "url(#bg-splash-right_svg__bT)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.3-277.7c54.1 67.2 84 42.2 138.1 109.4S960.5-76.2 1014.6-9s84 42.2 138.1 109.4 24.1 92.1 78.2 159.3 84 42.2 138.1 109.4 24.1 92.1 78.2 159.3 84 42.2 138.1 109.4",
  stroke: "url(#bg-splash-right_svg__bU)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M790.7-271.4c54.6 66.8 84.5 41.7 139.1 108.5s24.7 91.8 79.3 158.6 84.5 41.7 139.1 108.5 24.7 91.8 79.3 158.6 84.5 41.7 139.1 108.5 24.7 91.8 79.3 158.6 84.5 41.7 139.1 108.5",
  stroke: "url(#bg-splash-right_svg__bV)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M783.1-265.1c55.1 66.4 84.9 41.2 140.1 107.6S948.5-66 1003.6.3s84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6 25.3 91.5 80.4 157.8 84.9 41.2 140.1 107.6",
  stroke: "url(#bg-splash-right_svg__bW)"
}));

const SvgBgSplashRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 1446 813"
}, props), _ref, _ref2);

export default SvgBgSplashRight;